module.exports = __webpack_public_path__ + "img/maria-after.eae6f523.png";